import { gql, useQuery } from '@apollo/client';
import { callSideEffects } from '../../util';
export const WISHLIST_CARD_QUERY = gql `
    query WishlistCardQuery($estabId: Int!, $request: ReviewsRequest, $format: DateFormats) {
        getEstabById(estabId: $estabId) {
            estabId
            name
            numberOfPhotos
            starRating
            tags {
                text
                themeColor
            }
            customerFeedback {
                overallRating
                overallRatingDisplay
                overallRatingDescription
                numberOfReviews
            }
            reviews(request: $request) {
                checkInDate(format: $format)
                comment
                id
                rating
                ratingFormatted
                reviewerLocation
                reviewerName
            }
            tripadvisorFeedback {
                rating
                numberOfReviews
                ratingImageUrl
                tripAdvisorURL
                reviews {
                    title
                    comment
                    publishedDate
                    ratingImageUrl
                }
            }
            geography {
                location
                province
                country
                latitude
                longitude
            }
        }
    }
`;
export function useWishlistCard(estabId, sideEffects, skipQuery) {
    return useQuery(WISHLIST_CARD_QUERY, {
        onCompleted: (data) => callSideEffects(sideEffects, data),
        ssr: false,
        skip: !estabId || skipQuery,
        variables: {
            estabId: parseInt(estabId),
            request: {
                countryCode: 'GB',
                pagination: {
                    limit: 5,
                    offSet: 0,
                },
            },
            format: 'DEFAULT',
        },
    });
}
